/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Calendar } from '../../models/calendar';

export interface ApiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Params {
  companyId: string;
}

export function apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain(http: HttpClient, rootUrl: string, params: ApiV0CalendarEventTypeCompanyIdCalendarsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Calendar>>> {
  const rb = new RequestBuilder(rootUrl, apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain.PATH, 'get');
  if (params) {
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Calendar>>;
    })
  );
}

apiV0CalendarEventTypeCompanyIdCalendarsGet$Plain.PATH = '/api/v0/calendarEventType/{companyId}/calendars';
